import debounce from 'lodash.debounce';
import { IndexDictionary } from 'js/types/generic-types';

export function triggerOnScrollDepths(
  triggers: IndexDictionary<() => void>
): void {
  const debouncedHandleScroll: any = debounce(
    () => handleScroll(triggers, debouncedHandleScroll),
    200
  );
  window.addEventListener('scroll', debouncedHandleScroll);
}

function handleScroll(
  triggers: IndexDictionary<() => void>,
  debouncedHandleScroll: () => void
): void {
  const scrollFromTop: number = document.body.scrollHeight - window.innerHeight;
  const currentPercentage: number = (window.pageYOffset / scrollFromTop) * 100;
  const triggersArray: number[] = Object.keys(triggers)
    .map(Number)
    .sort((a, b) => a - b);
  let triggerValue: number = triggersArray[0];

  while (triggerValue <= currentPercentage) {
    const callback = triggers[triggerValue];

    if (callback) {
      callback();

      delete triggers[triggerValue];
      triggerValue = Number(Object.keys(triggers)[0]);
    }
  }

  if (Number.isNaN(triggerValue)) {
    window.removeEventListener('scroll', debouncedHandleScroll);
  }
}
